/**
 * @description 首页课程分类 tab
 * @author Kody
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    size: number;
    enterprise_id?: string;
}

interface IOutput {
    id: string;
    parent_id: string;
    name: string;
    name_letter: string;
    show_index: string;
    auth_type: string;
}

export const getTopLevelCategory = (data: IInput): Promise<IResponse<IOutput[]>> => {
    return fetchData(Api.GET_TOP_LEVEL_CATEGORY, data).then((res: IResponse<IOutput[]>) => {
        return res;
    });
};
